import { GroupContentsFragmentDoc, GroupDefaultFragmentDoc } from '@/graphql/operations.gen';
import { ApolloClient } from '@apollo/client/core';

export const getCachedGroup = (apolloClient: ApolloClient<any>, id: string) => {
  const cachedGroup = apolloClient.readFragment({
    id: `Group:${id}`,
    fragment: GroupDefaultFragmentDoc,
    fragmentName: 'GroupDefault',
  });

  const cachedGroupContents = apolloClient.readFragment({
    id: `Group:${id}`,
    fragment: GroupContentsFragmentDoc,
    fragmentName: 'GroupContents',
  });

  return { ...cachedGroup, ...cachedGroupContents };
};
